import React, { useImperativeHandle, useRef, useState, forwardRef } from 'react'
import { url } from '../../constants/url';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/UserContext';
import { Icon } from '@iconify/react/dist/iconify.js';
import "./AddProject.css"

const AddProject = forwardRef((props, ref) => {

  const {
    capitalizeFirstLetter,
    validateEmail,
    specialChars,
    fetchProjectDetails,
    openNewProject,
    setOpenNewProject,
    suggestionsRef,
    newProjectRef,
    suggestions,
    filteredSuggestions,
    setFilteredSuggestions,

  } = props

  const { logout } = useAuth()

  const [clientName, setClientName] = useState('');
  const [clientType, setClientType] = useState('');
  const [projectName, setProjectName] = useState('');
  const [applicationType, setApplicationType] = useState('');
  const [environmentType, setEnvironmentType] = useState('');
  const [testStartDate, setTestStartDate] = useState('');
  const [testEndDate, setEndDate] = useState('');
  const [projectType, setProjectType] = useState('');
  const [applicationOrRegularEntity, setApplicationOrRegularEntity] = useState('');
  const [email, setEmail] = useState('');
  const [teamLead, setTeamLead] = useState('')
  const [scope, setScope] = useState('')
  const [clientLeadEmail, setClientLeadEmail] = useState('')
  const [scopeFile, setScopeFile] = useState(null);
  const [scopeFiles, setScopeFiles] = useState(null);

  const [clientNameError, setClientNameError] = useState('');
  const [clientTypeError, setClientTypeError] = useState('');
  const [projectNameError, setProjectNameError] = useState('');
  const [applicationtypeError, setApplicationTypeError] = useState('');
  const [environmentTypeError, setEnvironmentTypeError] = useState('');
  const [startDateError, setStartDateError] = useState('');
  const [enddateError, setEndDateError] = useState('');
  const [projectTypeError, setProjectTypeError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [scopeError, setScopeError] = useState('');
  const [clientLeadEmailError, setClientLeadEmailError] = useState('')
  const [teamLeadError, setTeamLeadError] = useState('')


  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjectId, setEditingProjectId] = useState(null);


  const [addButtonDisable, setAddButtonDisable] = useState(false)
  const [loading, setLoading] = useState(false)


  const handleScopeFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!allowedTypes.includes(file.type)) {
        alert("Only Excel files are allowed!");
        e.target.value = null;
        setScopeFile(null);
        return;
      }
      setScopeFile(file);
    }
  };

  const handleTeamLeadChange = (e) => {
    const input = e.target.value;
    setTeamLead(input);
    const filtered = suggestions.filter((name) =>
      name.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredSuggestions(filtered);
  };

  const handleSuggestionClick = (suggestion) => {
    setTeamLead(suggestion);
    setFilteredSuggestions([]);
  };



  const handleAddproject = async (e) => {
    e.preventDefault();

    const capitalizedClientName = capitalizeFirstLetter(clientName);
    const capitalizedProjectName = capitalizeFirstLetter(projectName);

    if (capitalizedProjectName === '') {
      return setProjectNameError('Project name is required');
    }
    if (specialChars.test(capitalizedProjectName)) {
      return setProjectNameError('Invalid project name');
    }
    if (capitalizedClientName === '') {
      setClientNameError('Client name is required');
      return;
    }
    if (specialChars.test(capitalizedClientName)) {
      setClientNameError('Invalid client name');
      return;
    }
    if (clientType === '') {
      return setClientTypeError('Client type is required');
    }
    if (projectType === '') {
      return setProjectTypeError('Project status is required');
    }
    if (applicationType === '') {
      return setApplicationTypeError('Application Type is required');
    }
    if (
      !["VA Scan", "Configuration Review", "External Network Penetration Testing", "Internal Network Penetration Testing"].includes(applicationType) &&
      environmentType === ""
    ) {
      return setEnvironmentTypeError("Environment Type is required");
    }


    if (email === '') {
      return setEmailError('Client email is required');
    }
    if (!validateEmail(email)) {
      return setEmailError('Enter valid email');
    }

    try {
      setAddButtonDisable(true);
      setLoading(true);

      const formData = new FormData();
      formData.append("clientName", capitalizedClientName);
      formData.append("projectName", capitalizedProjectName);
      formData.append("applicationType", applicationType);
      formData.append("applicationOrRegularEntity", applicationOrRegularEntity);
      formData.append("testStartDate", testStartDate);
      formData.append("testEndDate", testEndDate);
      formData.append("projectType", projectType);
      formData.append("clientType", clientType);
      formData.append("email", email);
      formData.append("teamLead", teamLead);
      formData.append("environmentType", environmentType);
      formData.append("scope", scope)

      if (scopeFile) {
        formData.append("scope", scopeFile);
      }

      const response = await fetch(`${url}/addproject`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });

      if (response.ok) {
        setAddButtonDisable(false);
        fetchProjectDetails();
        setLoading(false);
        toast.success('Project added successfully...', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        clearInput();
        return;
      }

      if (response.status === 404) {
        setAddButtonDisable(false);
        setLoading(false);
        toast.error('Team Lead not exists', { position: 'top-right', autoClose: 2500 });
      }
      if (response.status === 400) {
        setAddButtonDisable(false);
        setLoading(false);
        toast.error('Invalid Input', { position: 'top-right', autoClose: 2500 });
      }
      if (response.status === 422) {
        setAddButtonDisable(false);
        setLoading(false);
        toast.error('Invalid client email', { position: 'top-right', autoClose: 2500 });
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", { position: 'top-right', autoClose: 2500 });
        return;
      }
    } catch (error) {
      console.error('Error adding project:', error);
      setAddButtonDisable(false);
      setLoading(false);
      toast.error('Error adding project', { position: 'top-right', autoClose: 2500 });
    }
  };


  const handleUpdateProject = async (id) => {
    try {
      const formData = new FormData();
      formData.append("projectId", id);
      formData.append("projectName", projectName);
      formData.append("clientName", clientName);
      formData.append("clientType", clientType);
      formData.append("projectType", projectType);
      formData.append("applicationType", applicationType);
      formData.append("applicationOrRegularEntity", applicationOrRegularEntity);
      formData.append("environmentType", environmentType);
      formData.append("scope", scope);
      formData.append("teamLead", teamLead);
      formData.append("testStartDate", testStartDate);
      formData.append("testEndDate", testEndDate);
      formData.append("clientEmail", email);


      if (scopeFile) {
        formData.append("scope", scopeFile);
      }

      const response = await fetch(`${url}/updateprojectdetails`, {
        method: "PUT",
        credentials: "include",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Project updated successfully...", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setOpenNewProject(false);
        setIsEditMode(false);
        setEditingProjectId(null);
        fetchProjectDetails();
        clearInput();
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };


  const handleEdit = async (id) => {
    setOpenNewProject(true);
    try {
      const response = await fetch(`${url}/editproject?projectId=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      const data = await response.json();

      if (data.files && data.files.length > 0) {
        const fileName = data.files[0].fileName;
        setScopeFiles(fileName);
      }

      // Set form fields
      setProjectName(data.project?.projectName || '');
      setClientName(data.project?.clientName || '');
      setClientType(data.project?.clientType || '');
      setProjectType(data.project?.projectType || '');
      setApplicationOrRegularEntity(data.project?.applicationOrRegularEntity || '');
      setApplicationType(data.project?.applicationType || '');
      setEnvironmentType(data.project?.environmentType || '');
      setScope(data.project?.scope || '');
      setTeamLead(data.project?.teamLead || '');
      setTestStartDate(data.project?.testStartDate?.substring(0, 10) || '');
      setEndDate(data.project?.testEndDate?.substring(0, 10) || '');
      setEmail(data.project?.clientEmail || '');
      setScopeFile(data.files.fileName)

      // Set edit mode
      setIsEditMode(true);
      setEditingProjectId(id);
      setOpenNewProject(true);
    } catch (error) {
      console.log(error);
    }
  };

  useImperativeHandle(ref, () => ({
    handleEdit
  }));


  const handleCancelProject = () => {
    setOpenNewProject(false)
    setClientName('');
    setProjectName('');
    setApplicationType('');
    setApplicationOrRegularEntity('');
    setTestStartDate('');
    setEndDate('');
    setProjectType('');
    setEmail('');
    setTeamLead('')
    setEnvironmentType('')
    setClientNameError('');
    setProjectNameError('');
    setApplicationTypeError('');
    setEndDateError('');
    setStartDateError('');
    setProjectTypeError('');
    setEmailError('');
    setTeamLeadError('')
    setEnvironmentTypeError('')
    setAddButtonDisable(false)
    setClientType('')
    setScope('')
    setScopeError('')
    setOpenNewProject(false);
    setIsEditMode(false);
    setEditingProjectId(null);
    setScopeFile(null)
    setScopeFiles('')
  }

  const clearInput = () => {
    setClientName('');
    setProjectName('');
    setApplicationType('');
    setTestStartDate('')
    setEndDate('');
    setProjectType('');
    setEmail('');
    setTeamLead('')
    setEnvironmentType('')
    setAddButtonDisable(false)
    setClientType('')
    setOpenNewProject(false)
    setScope('')
  }




  return (
    <div className='wrap_add_new_project_page' style={{ display: openNewProject ? 'block' : 'none', }}>
      <div className='wrap_new_project_content'>
        <div className='wrap_headingf_newproject'>
          <h1>{isEditMode ? 'Edit Project' : 'New Project'}</h1>
          <button onClick={handleCancelProject}><Icon icon="material-symbols:close" width="20" height="20" /></button>
        </div>
        <div className='wrap_add_project_content'>

          <div className='project_input_second'>
            <label>Project name</label>
            <input
              data-testid='project-name'
              type='name'
              value={projectName}
              placeholder='Enter project name'
              onChange={(e) => {
                setProjectName(capitalizeFirstLetter(e.target.value));
                setProjectNameError('');
              }}
            />
            {projectNameError && <p>{projectNameError}</p>}
          </div>

          <div className='project_input_first'>
            <label>Company name</label>
            <input
              value={clientName}
              placeholder='Enter client name'
              onChange={(e) => {
                setClientName(capitalizeFirstLetter(e.target.value));
                setClientNameError('');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleAddproject(e);
                  e.target.blur();
                }
              }}
            />
            {clientNameError && <p className='error'>{clientNameError}</p>}
          </div>



          <div className='project_field_wrap'>
            <div className='project_input_three'>
              <label>Project type</label>
              <select
                data-testid='Select'
                value={clientType}
                placeholder='select'
                onChange={(e) => {
                  setClientType(e.target.value);
                  setClientTypeError('');
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleAddproject(e);
                    e.target.blur();
                  }
                }}
              >
                <option>Select</option>
                <option>Commercial</option>
                <option>Government</option>
                <option>Commercial CertIn</option>

              </select>
              {clientType && clientType === '' ? <p>{clientTypeError}</p> : null}
            </div>

            <div className='project_input_three'>
              <label>Report type</label>
              <select
                data-testid='Select'
                value={projectType}

                onChange={(e) => {
                  setProjectType(e.target.value);
                  setProjectTypeError('');
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleAddproject(e);
                    e.target.blur();
                  }
                }}>
                <option>Select</option>
                <option>CERT-In</option>
                <option>NON CERT-In</option>
                <option>Blue CERT-In</option>

              </select>
              {projectType && projectType === '' ? <p>{projectTypeError}</p> : null}
            </div>

            <div className='project_input_four'>
              <label>Application type</label>
              <select
                data-testid='Select'
                value={applicationType}
                placeholder='select'
                onChange={(e) => {
                  setApplicationType(e.target.value);
                  setApplicationTypeError('');
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleAddproject(e);
                    e.target.blur();
                  }
                }}>
                <option>Select</option>
                <option>WEB</option>
                <option>API</option>
                <option>IOS</option>
                <option>ANDROID</option>
                <option>ANDROID & IOS</option>
                <option>Desktop App</option>
                <option>Secure Code Review</option>
                <option>VA Scan</option>
                <option>Configuration Review</option>
                <option>External Network Penetration Testing</option>
                <option>Internal Network Penetration Testing</option>
              </select>
              {applicationtypeError && applicationType === '' ? <p>{applicationtypeError}</p> : null}
            </div>

            <div className='project_input_four'>
              <label>Application / Regular Entity (Optional)</label>
              <select
                data-testid='Select'
                value={applicationOrRegularEntity}
                placeholder='select'
                onChange={(e) => {
                  setApplicationOrRegularEntity(e.target.value);
                }}
              >
                <option>Select</option>
                <option>360 ONE AMC - MF</option>
                <option>360 ONE AMC - PMS</option>
                <option>360 ONE PMS</option>
                <option>360 ONE AAM</option>
                <option>360 ONE Prime</option>
                <option>360 ONE Wealth</option>
                <option>360 ONE DSL</option>
                <option>360 IATSL</option>
                <option>360 ONE AMC</option>
              </select>
            </div>

            {applicationType !== 'VA Scan' && applicationType !== 'Configuration Review' && applicationType !== 'External Network Penetration Testing' && applicationType !== 'Internal Network Penetration Testing' ? (
              <div className='project_input_three'>
                <label>Environment type</label>
                <select
                  data-testid='Select'
                  value={environmentType}
                  onChange={(e) => {
                    setEnvironmentType(e.target.value);
                    setEnvironmentTypeError('');
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleAddproject(e);
                      e.target.blur();
                    }
                  }}>
                  <option>Select</option>
                  <option>Staging</option>
                  <option>Production</option>
                </select>
                {environmentTypeError && environmentType === '' ? <p>{environmentTypeError}</p> : null}
              </div>
            ) : (
              ''
            )}

            {applicationType !== 'VA Scan' && applicationType !== 'Configuration Review' && applicationType !== 'External Network Penetration Testing' && applicationType !== 'Internal Network Penetration Testing' ? (
              <div className='project_input_first'>
                <label>Scope</label>
                <textarea
                  value={scope}
                  placeholder={`Scope URL's`}
                  onChange={(e) => {
                    setScope(e.target.value);
                    setScopeError('');
                  }}
                />
                {scopeError && <p className='error'>{scopeError}</p>}
              </div>
            ) : (
              <div className='project_input_first'>
                <label>Scope Details</label>
                <input
                  type='file'
                  style={{ height: '40px' }}
                  accept=".xls,.xlsx"
                  onChange={handleScopeFileChange}
                />
                <p style={{ color: 'black', marginBottom: '10px' }}>Only excel sheets are allowed.</p>
                {scopeFiles && (
                  <p style={{ color: 'green', marginTop: '5px' }}>
                    Current file: <strong>{scopeFiles}</strong>
                  </p>
                )}
              </div>
            )}

            <div className='project_field_wrap'>
              <div className='project_input_seven'>
                <label>Isecurion team lead</label>
                <input
                  value={teamLead}
                  ref={newProjectRef}
                  data-testid='input-email'
                  onChange={handleTeamLeadChange}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleAddproject(e);
                      e.target.blur();
                    }
                  }}
                  placeholder='Enter team lead name'
                />
                {filteredSuggestions.length > 0 && (
                  <div className='wrap_user_dropdown'>
                    <ul className='suggestions_user_details' ref={suggestionsRef}>
                      {filteredSuggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          onClick={() => handleSuggestionClick(suggestion)}>
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {teamLeadError && <p>{teamLeadError}</p>}
              </div>

              <div className='project_input_six'>
                <label>Test start date</label>
                <input
                  data-testid='input-enddate'
                  type='date'
                  value={testStartDate}
                  onChange={(e) => {
                    setTestStartDate(e.target.value);
                    setStartDateError('');
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleAddproject(e);
                      e.target.blur();
                    }
                  }}
                />
                {/* {enddateError && testEndDate === '' ? <p>{enddateError}</p> : null} */}
              </div>

              <div className='project_input_six'>
                <label>Test end date</label>
                <input
                  data-testid='input-enddate'
                  type='date'
                  value={testEndDate}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                    setEndDateError('');
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleAddproject(e);
                      e.target.blur();
                    }
                  }}
                />
                {/* {enddateError && testEndDate === '' ? <p>{enddateError}</p> : null} */}
              </div>

              <div className='project_input_eight'>
                <label>Client manager email</label>
                <input
                  value={email}
                  data-testid='input-email'
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError('');
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleAddproject(e);
                      e.target.blur();
                    }
                  }}
                  placeholder='Enter project client manager email'
                />
                {emailError && <p>{emailError}</p>}
              </div>

              {/* <div className='project_input_eight'>
                      <label>Client team lead email</label>
                      <input
                        value={clientLeadEmail}
                        data-testid='input-email'
                        onChange={(e) => {
                          setClientLeadEmail(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleAddproject(e);
                            e.target.blur();
                          }
                        }}
                        placeholder='Enter project client team lead email'
                      />
                      {clientLeadEmailError && <p>{clientLeadEmailError}</p>}
                    </div> */}

              <div className='project_input_nine'>

                <button
                  disabled={addButtonDisable}
                  onClick={isEditMode ? () => handleUpdateProject(editingProjectId) : handleAddproject}
                >
                  {loading ? (
                    <span>{isEditMode ? 'Updating...' : 'Adding...'}</span>
                  ) : (
                    isEditMode ? 'Update Project' : 'Add Project'
                  )}
                </button>


              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  )
})

export default AddProject
